import { TextField } from '@mui/material'
import { forwardRef, ForwardedRef } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { CustomTextField } from '.'
import { EFInputLabel } from '../EFInputLabel'
import { EFTextFieldProps } from './EFTextField.model'
import classNames from 'classnames/bind'
import styles from './EFTextField.module.scss'
import { getNestedError } from '~/utils/objectHelper'

const cx = classNames.bind(styles)
export const EFTextField = forwardRef(
  (props: EFTextFieldProps, _ref: ForwardedRef<unknown>) => {
    const { control, setValue, formState } = useFormContext() ?? {}
    const theme = useAppSelector(currentTheme)
    const {validateFn, blurFn, ...baseProps} = props; //Some of these props shouldnt be passed down

    if (!control) return <CustomTextField {...baseProps} />

    return (
      <Controller     
        control={control}
        name={props.name}
        rules={{ validate: props.validateFn }}
        render={({ field, fieldState }) => (
          <div className='custom-field'>
            {props.label && (
              <EFInputLabel
                label={props.label}
                name={props.name}
                style={props.style}
              />
            )}
            <TextField
              error={fieldState.invalid === true}
              helperText={
                fieldState.invalid === true
                  ? getNestedError(formState, `errors.${field.name}.message`)
                  : undefined
              }
              {...baseProps}
              {...field}
              sx={{
                ...baseProps.sx,
                '& *': { color: props.style?.color }
              }}
              autoComplete={props.autocompletehint ?? 'new-password'}
              type={props.type ?? 'text'}
              name={field.name}
              value={field.value ?? ''}
              placeholder={props.placeholder}
              id={field.name}
              FormHelperTextProps={{
                sx: { marginX: 0, color: 'red !important' }
              }}
              InputLabelProps={{ style: { display: 'none' }, shrink: false }}
              className={cx('text-field', theme)}
              onChange={(e: any) => {
                let parsedValue = e.target.value;
                if(props.type === 'number'){
                  let asNum = Number.parseFloat(parsedValue);
                  if(Number.isNaN(asNum)){
                    parsedValue = null;
                  }
                }
                setValue(field.name, parsedValue, {
                  shouldValidate: true,
                  shouldDirty: true
                })
                props.onChange?.(e)
              }}
              onBlur={(e: any) => {
                props.blurFn?.(e);
              }}
            />
          </div>
        )}
      />
    )
  }
)
